import cls from "@fvilers/cls";
import { UndoIcon } from "@imi/icons/UndoIcon.js";
import { Button } from "@imi/ui/components/Button/Button.js";
import {
  DialogActions,
  DialogBody,
  DialogClose,
  DialogCloseButton,
} from "@imi/ui/components/Dialog/Dialog.js";
import { DialogBodyProps } from "@imi/ui/components/Dialog/DialogBody.js";
import { LoadingSpinner } from "@imi/ui/components/LoadingSpinner/LoadingSpinner.js";
import { useTranslation } from "react-i18next";
import styles from "./DialogLoadingFallback.module.css";

type DialogLoadingFallbackProps = DialogBodyProps;

export function DialogLoadingFallback({
  className,
  ...props
}: DialogLoadingFallbackProps) {
  const { t } = useTranslation("dialogs");
  return (
    <>
      <DialogBody
        className={cls(className, styles.DialogLoadingFallback)}
        {...props}
      >
        <LoadingSpinner className={styles.LoadingSpinner} />
      </DialogBody>

      <DialogActions>
        <Button disabled variant="outline">
          <UndoIcon />
          {t("loading.reset")}
        </Button>
        <DialogClose variant="outline">{t("loading.cancel")}</DialogClose>
        <Button disabled>{t("loading.confirm")}</Button>
      </DialogActions>
      <DialogCloseButton>{t("loading.close")}</DialogCloseButton>
    </>
  );
}
